export default "__VITE_ASSET__h$VmjSXA__"